var map = {
	"./AffiliatePage.vue": 5369,
	"./Affiliate_DetailPage.vue": 4998,
	"./Affiliate_WithdrawPage.vue": 1206,
	"./BuyPage.vue": 7978,
	"./DashboardPage.vue": 4806,
	"./HomePage.vue": 6609,
	"./LicensePage.vue": 3722,
	"./SupportPage.vue": 7629,
	"./TransferPage.vue": 9854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5262;